import { call, put, takeLatest, all, takeEvery } from "redux-saga/effects";

import {
  HISTORICAL_LOAD_REQUESTING,
  HISTORICAL_ERROR,
  HISTORICAL_REFRESH_REQUESTING,
  SELECT_FEEDBACK,
} from "./constants";

import { loadHistorical, refreshHistorical } from "./actions";

import { fetchApi } from "../api";
import { navigate } from "../navigation/navigatorHelper";

const endPoints = {
  getAllHistorical: "/v1/users/get-all-historical",
};

const getAllHistoricalApi = data => {
  return fetchApi(endPoints.getAllHistorical, data, "post");
};

function* loadHistoricalFlow(action) {
  try {
    const { userId, historicalIndex } = action.payload;

    const response = yield call(getAllHistoricalApi, {
      userId,
      historicalIndex,
    });
    yield put(loadHistorical(response));
  } catch (error) {
    console.log(error);
    yield put({ type: HISTORICAL_ERROR });
  }
}

function* refreshHistoricalFlow(action) {
  try {
    const { userId } = action.payload;

    const response = yield call(getAllHistoricalApi, {
      userId,
      historicalIndex: 0,
    });
    yield put(refreshHistorical(response));
  } catch (error) {
    console.log(error);
    yield put({ type: HISTORICAL_ERROR });
  }
}

function* selectFeedbackNavigationFlow(action) {
  navigate("HistoricalAction");
}

// Watches for the SIGNUP_REQUESTING action type
// When it gets it, it will call signupFlow()
// WITH the action we dispatched
function* feedWatcher() {
  yield all([
    takeLatest(HISTORICAL_LOAD_REQUESTING, loadHistoricalFlow),
    takeLatest(HISTORICAL_REFRESH_REQUESTING, refreshHistoricalFlow),
    takeLatest(SELECT_FEEDBACK, selectFeedbackNavigationFlow),
  ]);
}

export default feedWatcher;
